import * as React from "react";
import { cn } from "@/lib/utils";
import { ScopeNav } from "./scope-nav";

export interface IndexPageHeaderTitleProps {
  title: string;
  kicker?: React.ReactNode;
  onPrev?: () => void;
  onNext?: () => void;
  className?: string;
}

export function IndexPageHeaderTitle({
  title,
  kicker,
  onPrev,
  onNext,
  className,
}: IndexPageHeaderTitleProps) {
  return (
    <div
      className={cn(
        "flex flex-wrap items-center justify-between gap-x-4 gap-y-2 bg-surface",
        "px-4 py-4 md:border-b md:border-line md:px-6 md:py-3.5",
        className,
      )}
    >
      <div className="flex items-baseline gap-3">
        <h1
          className="text-xl font-semibold text-ink-900 md:text-[18px]"
          style={{
            fontFamily: "var(--font-display)",
            letterSpacing: "-.015em",
          }}
        >
          {title}
        </h1>
        {kicker ? (
          <span className="hidden font-mono text-[11px] uppercase tracking-[.08em] text-ink-500 md:inline">
            {kicker}
          </span>
        ) : null}
      </div>
      {onPrev && onNext ? <ScopeNav onPrev={onPrev} onNext={onNext} /> : null}
    </div>
  );
}

export function IndexPageHeaderTabs({ children }: { children: React.ReactNode }) {
  return <div className="border-b border-line bg-surface px-4 md:px-6">{children}</div>;
}

export function IndexPageHeaderToolbar({ children }: { children: React.ReactNode }) {
  return (
    <div className="flex flex-wrap items-center justify-between gap-3 border-b border-line bg-surface px-4 py-2.5 md:px-6">
      {children}
    </div>
  );
}

export function IndexPageHeader({ children }: { children: React.ReactNode }) {
  return <div>{children}</div>;
}
